import apiClient from "./axios"

// ✅ Get Car Care accounts (with filters / pagination)
export const getCarCareAccounts = async (params = {}) => {
  const { data } = await apiClient.get("/car-care-accounts", { params })
  return data
}

// ✅ Get single Car Care account by ID
export const getCarCareAccount = async id => {
  const { data } = await apiClient.get(`/car-care-accounts/${id}`)
  return data
}

// ✅ Create Car Care account
export const createCarCareAccount = async payload => {
  const { data } = await apiClient.post("/car-care-accounts", payload)
  return data
}

// ✅ Update Car Care account
export const updateCarCareAccount = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/car-care-accounts/${id}`, payload)
  return data
}

// ✅ Delete Car Care account
export const deleteCarCareAccount = async id => {
  const { data } = await apiClient.delete(`/car-care-accounts/${id}`)
  return data
}
